import styled from 'styled-components';
import { theme } from '../ui/theme';

export const OverlayContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: white;
    z-index: ${theme.zIndex.overlay};
    overflow-y: auto;
    max-height: 100%;
`;
